import React, { FormEvent, useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  Alert,
} from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import styles from "./Login.module.css";
import CpfField from "../../atoms/CpfField/CpfField";
import PasswordField from "../../atoms/PasswordField/PasswordField";
import { useAuth } from "../../../resources/AuthProvider";
import { useNavigate } from "react-router-dom";
import Logo from "../../../assets/logo_siscap.svg";

const Login: React.FC = () => {
  //const recaptchaEnabled = process.env.REACT_APP_RECAPTCHA_ENABLED !== "false";
  const recaptchaEnabled = false;
  console.log('recaptchaEnabled', recaptchaEnabled);
  const [cpf, setCPF] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [msgError, setMsgError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e?: FormEvent) => {
    e?.preventDefault();
    try {

      if (!cpf) {
        setMsgError('Por favor, informe o CPF.');
        return;
      }

      if (!password) {
        setMsgError('Por favor, informe a senha.');
        return;
      }
      if (recaptchaEnabled && !captchaToken) {
        setMsgError('Confirme que você não é um robô.');
        return;
      }
      const resolvedCaptchaToken = captchaToken ?? "";
      setLoading(true);
      const response = await login(cpf, password, resolvedCaptchaToken);
      setLoading(false);
      navigate(response.force_password_change ? "/alterar-senha-obrigatoria" : "/");
    } catch (error) {
      setMsgError('Usuário ou senha inválidos.');
      setLoading(false);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    if (msgError) {
      setTimeout(() => {
        setMsgError(null);
      }, 5000);
    }
  }, [msgError]);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        {/* Lado Direito */}
        <div className={styles.cardRight}>
          <div className={styles.divImage3}>
            <img
              src={Logo}
              alt="Cadeado SISCAP"
              className={styles.cadeado}
            />
          </div>
          <h2 className={styles.title}>Acesse sua conta</h2>
          <form className={styles.form} onSubmit={handleSubmit}>
            {msgError && (
              <div className={styles.inputGroup}>
                <Alert severity="error">{msgError}</Alert>
              </div>
            )}
            {/* Campo CPF */}
            <div className={styles.inputGroup}>
              <label className={styles.titleInput}>
                CPF
              </label>
              <CpfField
                size="small"
                placeholder=""
                variant="standard"
                autoFocus={false}
                value={""}
                onUpdate={setCPF}
                customClassName={styles.input}
                numericKeyboard
              />
            </div>

            {/* Campo Senha */}
            <div className={styles.inputGroup}>
              <label className={styles.titleInput2}>
                SENHA
              </label>
              <PasswordField
                testeid="confirmarSenha"
                fullWidth
                label=""
                isLogin={false}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                margin="normal"
                variant="standard"
                customClassName={styles.input}
              />
              {/* Link esqueceu a senha */}
              <div className={styles.blForgotPass}>
                <a href="/recuperar-senha" className={styles.link}>
                  Esqueceu a senha?
                </a>
              </div>
            </div>

            {/* Botões Entrar e Criar Conta */}
            {recaptchaEnabled && (
              <div className={styles.captchaWrapper}>
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ""}
                  onChange={(token: string | null) => setCaptchaToken(token)}
                  onExpired={() => setCaptchaToken(null)}
                  onErrored={() => setCaptchaToken(null)}
                />
              </div>
            )}

            <div className={styles.blButtons}>
              <div className={styles.buttonGroup}>
                <button 
                  type="submit"
                  disabled={loading} 
                  className={`${styles.button} ${(loading) ? styles.buttonLoad : ''} `}
                >
                  {loading ? (
                    <>
                    <div className={styles.spinner}></div>
                    <span>Entrando...</span>
                    </>
                  ) : (
                  <span>Entrar</span>
                  )}

                </button>
              </div>
              <div className={styles.buttonGroup}>
                <button
                  type="button" 
                  className={`${styles.button2} ${(loading) ? styles.buttonOpacity : ''} `}
                  disabled={loading} 
                  onClick={() => navigate('/cadastro')}
                >
                  Criar Conta
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* Diálogo de erro */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Erro de Login</DialogTitle>
        <DialogActions>
          <div className="flex flex-col ">
            <Button onClick={handleCloseDialog} color="primary">
              Fechar
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Login;
